import { Link } from "@tanstack/react-router";
import { Box } from "lucide-react";
import { fr } from "@/i18n/fr";

interface WordmarkProps {
	to?: "/" | "/catalogue";
	/** Over the ink surface: page-coloured text, accent mark kept. */
	onInk?: boolean;
}

/** "Montage 3D" set in the display face after a small sage mark (the app has no logo yet). */
export function Wordmark({ to = "/", onInk }: WordmarkProps) {
	const color = onInk
		? "text-on-ink hover:text-on-ink"
		: "text-fg hover:text-fg";
	return (
		<Link
			to={to}
			className={`inline-flex shrink-0 items-center gap-2 whitespace-nowrap font-display text-lg no-underline ${color}`}
		>
			<span className="grid size-[22px] place-items-center rounded-[7px] bg-accent text-accent-fg">
				<Box className="size-3.5" strokeWidth={2.25} aria-hidden="true" />
			</span>
			{fr.appTitle}
		</Link>
	);
}
